__turbopack_context__.v({
  "bannerItem": "popup-banners-module-sass-module__eVUypq__bannerItem",
  "bannerModal": "popup-banners-module-sass-module__eVUypq__bannerModal",
  "banners": "popup-banners-module-sass-module__eVUypq__banners",
  "close": "popup-banners-module-sass-module__eVUypq__close",
});
